import React from "react";
// import EventView from "./EventView";
import { connect } from "react-redux";
import {
    selectDayRange,
    selectTracks,
    selectWeekCount
} from "../redux/selectors";
import {
    openEditEventModal,
    setFocussedEvent,
    setFocussedEventIndices,
    setEventTimeAction
} from "../redux/actions";
class EventControl extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dragSection: false,
            dragIndex: false,
            dragging: false,
            width: props.event.end - props.event.start,
            deselectListener: false,
            start: false,
            end: false
        };
    }

    onDragStart = (type, index = false, row = false) => {
        this.setState({
            ...this.state,
            dragSection: type,
            dragIndex: index,
            dragging: true,
            selected: true,
            dragRow: this.props.row,
            width: this.props.event.end - this.props.event.start
        });

        this.props.dragStart(this.props.index, this.props.row);
    };

    onDrag = type => {
        if (
            this.props.dragging === false ||
            (this.props.dragTimeBlockIndex === false &&
                this.props.dragTimeBlockRow === false) ||
            this.props.eventId !== this.props.id
        ) {
            return;
        }

        const dragTimeBlockIndex = this.props.dragTimeBlockIndex;
        let eventStart = null;
        let eventEnd = null;

        if (type === "middle") {
            const start = dragTimeBlockIndex - this.state.dragIndex + 1;
            if (start < 1) {
                return;
            }

            eventStart = start - 1;
            eventEnd = start + this.state.width - 1;
            this.setState({
                ...this.state,
                width: eventEnd - eventStart
            });
        }

        if (type === "left") {
            const start = dragTimeBlockIndex + 1;
            const end = this.props.event.end + 1;
            const width = end - start;

            if (width < 1) {
                return;
            }

            eventStart = start - 1;
            eventEnd = end - 1;

            this.setState({
                ...this.state,
                width
            });
        }

        if (type === "right") {
            // const start = this.state.position.gridColumnStart;
            const start = this.props.event.start + 1;
            const end = dragTimeBlockIndex + 2;
            const width = end - start;

            if (width < 1) {
                return;
            }

            eventStart = start - 1;
            eventEnd = end - 1;

            this.setState({
                ...this.state,
                width
            });
        }

        if (
            eventStart !== this.state.start ||
            eventEnd !== this.state.end ||
            this.props.dragTimeBlockRow !== this.state.row
        ) {
            eventEnd =
                eventEnd > this.props.weekCount * 7
                    ? this.props.weekCount * 7
                    : eventEnd;
            this.setState(
                {
                    ...this.state,
                    start: eventStart,
                    end: eventEnd,
                    width: eventEnd - eventStart,
                    row: this.props.dragTimeBlockRow
                },
                () => {
                    this.props.setEventTimeAction(
                        this.props.event,
                        eventStart,
                        eventEnd,
                        this.props.parentTrackIndex,
                        this.props.childTrackIndex,
                        this.props.dayRange.start,
                        this.props.tracks,
                        this.props.dragTimeBlockRow + 1
                    );
                }
            );
        }
    };

    onDragEnd = () => {
        this.setState({
            ...this.state,
            dragSection: false,
            dragIndex: false,
            dragging: false,
            dragRow: false
        });

        this.props.dragEnd();
    };

    onClick = e => {
        this.setState({
            ...this.state,
            selected: true
        });
    };

    onBlur = e => {
        this.props.onBlur();

        this.props.setFocussedEvent(this.props.event, false);
    };

    onFocus = e => {
        this.props.onFocus(this.props.index);

        this.props.setFocussedEvent(this.props.event, true);
        this.props.setFocussedEventIndices(
            this.props.parentTrackIndex,
            this.props.childTrackIndex,
            this.props.index
        );
    };

    onDoubleClick = e => {
        this.props.openEditEventModal();
    };

    checkIsVisible = () => {
        if (this.props.event.start > this.props.weekCount * 7 - 1) {
            return false;
        }

        if (this.props.event.end <= 0) {
            return false;
        }
    };

    render() {
        if (this.checkIsVisible() === false) {
            return null;
        }
        let leftPointerEvents =
            this.state.dragSection === false
                ? "all"
                : this.state.dragSection === "left"
                    ? "all"
                    : "none";

        let rightPointerEvents =
            this.state.dragSection === false
                ? "all"
                : this.state.dragSection === "right"
                    ? "all"
                    : "none";

        if (
            this.props.eventId !== this.props.id &&
            this.props.eventId !== false
        ) {
            rightPointerEvents = leftPointerEvents = "none";
        }
        const start = this.props.event.start < 1 ? 0 : this.props.event.start;
        const end =
            this.props.event.end > this.props.weekCount * 7
                ? this.props.weekCount * 7
                : this.props.event.end;
        const position = {
            gridColumnStart: start + 1,
            gridColumnEnd: end + 1,
            gridRowStart: this.props.event.row,
            gridRowEnd: this.props.event.row
        };

        if (
            this.props.index !== this.props.movingEventIndex &&
            this.props.dragging
        ) {
            rightPointerEvents = leftPointerEvents = "none";
        }

        let otherEnd = this.props.event.end;
        if (otherEnd > this.props.weekCount * 7) {
            otherEnd = this.props.weekCount * 7;
        }

        const width = otherEnd - this.props.event.start;

        if (width < 1 && typeof width === "undefined") {
            return null;
        }

        return (
            <React.Fragment>
                <div
                    className="EventControlContainer"
                    style={position}
                    onClick={this.onClick}
                    onDoubleClick={this.onDoubleClick}
                    onBlur={this.onBlur}
                    onFocus={this.onFocus}
                    tabIndex="0"
                >
                    {position.gridColumnStart < 1 ? null : (
                        <div
                            className={`EventControl EventControl-Left`}
                            onDragStart={() => this.onDragStart("left")}
                            onDrag={() => this.onDrag("left")}
                            onDragEnd={() => this.onDragEnd()}
                            draggable="true"
                            style={{
                                pointerEvents: leftPointerEvents
                            }}
                        />
                    )}

                    {new Array(width).fill(true).map((e, i) => {
                        const start = 0;
                        const end = width - 1;

                        let style = {};

                        if (width === 1) {
                            style = {
                                left: "4px",
                                width: `calc((100% / ${width}) - 8px)`
                            };
                        } else if (i === start) {
                            style = {
                                left: "4px",
                                width: `calc((100% / ${width}) - 4px)`
                            };
                        } else if (i === end) {
                            const leftFraction = end / width;
                            style = {
                                left: `calc(100% * ${leftFraction})`,
                                width: `calc((100% / ${width}) - 4px)`
                            };
                        } else {
                            const leftFraction = i / width;
                            style = {
                                left: `calc(100% * ${leftFraction})`,
                                width: `calc((100% / ${width}))`
                            };
                        }

                        let middlePointerEvents =
                            this.state.dragSection === false
                                ? "all"
                                : this.state.dragSection === "middle" &&
                                  this.state.dragIndex === i &&
                                  this.props.eventId === this.props.id
                                    ? "all"
                                    : "none";
                        if (
                            this.props.eventId !== this.props.id &&
                            this.props.eventId !== false
                        ) {
                            middlePointerEvents = "none";
                        }

                        if (
                            this.props.index !== this.props.movingEventIndex &&
                            this.props.dragging
                        ) {
                            middlePointerEvents = "none";
                        }

                        return (
                            <div
                                className={`EventControl EventControl-Middle`}
                                key={i}
                                onDragStart={() =>
                                    this.onDragStart("middle", i)
                                }
                                onDrag={() => this.onDrag("middle", i)}
                                onDragEnd={() => this.onDragEnd()}
                                draggable="true"
                                style={{
                                    ...style,
                                    pointerEvents: middlePointerEvents
                                }}
                            />
                        );
                    })}

                    <div
                        className={`EventControl EventControl-Right`}
                        onDragStart={() => this.onDragStart("right")}
                        onDrag={() => this.onDrag("right")}
                        onDragEnd={() => this.onDragEnd()}
                        draggable="true"
                        style={{
                            pointerEvents: rightPointerEvents
                        }}
                    />
                </div>
            </React.Fragment>
        );
    }
}

export default connect(
    store => {
        return {
            dayRange: selectDayRange(store),
            tracks: selectTracks(store),
            weekCount: selectWeekCount(store)
        };
    },
    {
        openEditEventModal,
        setFocussedEvent,
        setFocussedEventIndices,
        setEventTimeAction
    }
)(EventControl);
